import TopicsPage from "@/pages/_topics";
import { defineMessage, useIntl } from "react-intl";
import ErrorPage from "@/pages/_error";
import ForumHelmet from "@/components/ForumHelmet";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { CompetitionTopicsPageQuery as CompetitionTopicsPageQueryType } from "./__generated__/CompetitionTopicsPageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
import { getVotableOrderParam } from "@/utils/votableOrder";
export default function CompetitionTopicsPage() {
  const {
    query,
    variables: { order: initialOrder },
  } = useCompetitionTopicsPageQuery();
  const forum = query?.competitionBySlug?.forum;
  const event = query.competitionBySlug?.event.event;
  const intl = useIntl();
  if (!forum || !event) {
    return (
      <ErrorPage
        status={404}
        message={intl.formatMessage({
          defaultMessage: "Competition not found",
        })}
      />
    );
  }
  return (
    <ForumHelmet forum={forum} parent={event.slug}>
      <TopicsPage
        forum={forum}
        initialOrder={initialOrder}
        parent={event.slug}
      />
    </ForumHelmet>
  );
}
const CompetitionTopicsPageQuery = graphql`
  query CompetitionTopicsPageQuery(
    $owner: String!
    $slug: String!
    $order: VotableOrder!
  ) {
    competitionBySlug(slug: $slug) {
      event(slug: $owner) {
        event {
          slug
        }
      }
      forum {
        ...TopicsPageFragment @arguments(order: $order)
        ...ForumHelmetFragment
      }
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { slug: owner, track: slug }, request }: LoaderArgs) => {
    const order = getVotableOrderParam(request) || "NEWEST";
    if (!slug || !owner) {
      throw new Response("No slug or owner", { status: 500 });
    }
    return preload<CompetitionTopicsPageQueryType>(
      environment,
      CompetitionTopicsPageQuery,
      {
        owner,
        slug,
        order,
      },
    );
  };
};
const useCompetitionTopicsPageQuery = () =>
  usePreloaded<CompetitionTopicsPageQueryType>();

export const lazyHandle = {
  titleI18n: defineMessage({ defaultMessage: "Discussions" }),
};
